import { Box, Typography, Link, Paper } from "@mui/material";

const INSIGHT_TYPES = {
  INFO_SUCCESS_STORY: {
    icon: "ℹ️",
    color: "#6c757d", // Gris neutre
    label: "Information"
  },
  OPPORTUNITY: {
    icon: "💡",
    color: "#43a047", // Vert
    label: "Opportunité"
  },
  TREND: {
    icon: "📈",
    color: "#1976d2", // Bleu
    label: "Tendance"
  },
  ALERT: {
    icon: "⚠️",
    color: "#ff9800", // Orange
    label: "Alerte"
  }
};

const insights = [
  {
    type: "OPPORTUNITY",
    title: "Segment 'Acheteurs Catégorie X' en croissance",
    summary: "Taux de rachat supérieur à la moyenne sur les 60 derniers jours. Potentiel pour une campagne de fidélisation.",
    sourceSystem: "Mautic Analytics",
    timestamp: "Il y a 2 heures",
    link: { label: "Explorer", url: "#" }
  },
  {
    type: "ALERT",
    title: "Désengagement 'Prospects Qualifiés'",
    summary: "Le taux d'ouverture des emails a chuté de 15% ce mois-ci.",
    sourceSystem: "Email Analytics",
    timestamp: "Il y a 45 minutes",
    link: { label: "Analyser", url: "#" }
  },
  {
    type: "TREND",
    title: "Ventes de produits premium à la hausse",
    summary: "Les ventes ont augmenté de 25% sur les 3 derniers mois, avec un pic de 32% en juin.",
    sourceSystem: "Sales Analytics",
    timestamp: "Hier",
    link: { label: "Détails", url: "#" }
  },
  {
    type: "INFO_SUCCESS_STORY",
    title: "Campagne 'Promo Printemps' réussie",
    summary: "La campagne a dépassé les objectifs avec un taux de conversion de 8% sur le segment 'Clients VIP'.",
    sourceSystem: "Campaign Analytics",
    timestamp: "Il y a 3 jours",
    link: { label: "Consulter", url: "#" }
  }
];

const DashboardInsightsCard = () => (
  <Box
    sx={{
      background: "#fff",
      borderRadius: 3,
      boxShadow: "0 2px 12px 0 rgba(25, 118, 210, 0.06)",
      px: 3,
      py: 2.5,
      border: "1px solid #f1f3f4",
      minWidth: 320,
      maxWidth: 'none', 
      width: '100%', 
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      fontFamily: 'Montserrat, Arial, sans-serif',
      flexWrap: 'wrap',
    }}
  >
    {/* Titre de la section */}
    <Typography variant="subtitle1" sx={{ 
      color: "#1976d2", 
      fontWeight: 700, 
      mb: 2, 
      fontFamily: 'Montserrat, Arial, sans-serif',
      borderBottom: '2px solid #e3f0fe',
      pb: 1,
      display: 'flex',
      alignItems: 'center',
      gap: 1
    }}>
      <span>Insights du Co-Pilote IA</span>
      <Typography variant="body2" sx={{ color: '#495057', fontSize: 14 }}>
        ({insights.length} insights)
      </Typography>
    </Typography>

    {/* Liste des insights */}
    <Box display="flex" flexDirection="column" gap={2}>
      {insights.map((item, idx) => (
        <Paper 
          key={idx} 
          elevation={1} 
          sx={{ 
            p: 2,
            borderRadius: 2,
            backgroundColor: '#f8f9fa',
            transition: 'all 0.2s ease',
            '&:hover': {
              backgroundColor: '#f0f4fc',
              transform: 'translateY(-2px)'
            }
          }}
        >
          <Box display="flex" alignItems="flex-start" gap={2}>
            {/* Icône */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 40,
                height: 40,
                borderRadius: '50%',
                backgroundColor: INSIGHT_TYPES[item.type]?.color,
                color: 'white',
                fontSize: 24,
                flexShrink: 0
              }}
            >
              {INSIGHT_TYPES[item.type]?.icon}
            </Box>

            {/* Contenu principal */}
            <Box flex={1}>
              {/* Type et Métadonnées */}
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
                <Typography 
                  variant="caption" 
                  sx={{ 
                    color: INSIGHT_TYPES[item.type]?.color,
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    letterSpacing: 0.8
                  }}
                >
                  {INSIGHT_TYPES[item.type]?.label}
                </Typography>
                <Typography variant="caption" sx={{ color: '#6c757d' }}>
                  {item.timestamp}
                </Typography>
              </Box>

              {/* Titre */}
              <Typography 
                variant="subtitle2" 
                sx={{ 
                  fontWeight: 700, 
                  color: '#212529', 
                  fontSize: 15,
                  mb: 0.5
                }}
              >
                {item.title}
              </Typography>

              {/* Résumé */}
              <Typography 
                variant="body2" 
                sx={{ 
                  color: '#495057', 
                  fontSize: 14,
                  mb: 1.5
                }}
              >
                {item.summary}
              </Typography>

              {/* Source et Lien */}
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="caption" sx={{ color: '#6c757d' }}>
                  Source: {item.sourceSystem}
                </Typography>
                <Link 
                  href={item.link.url} 
                  underline="hover"
                  sx={{ 
                    color: INSIGHT_TYPES[item.type]?.color,
                    fontWeight: 600,
                    fontSize: 14
                  }}
                >
                  {item.link.label}
                </Link>
              </Box>
            </Box>
          </Box>
        </Paper>
      ))}
    </Box>
  </Box>
);

export default DashboardInsightsCard;
